// extracted by mini-css-extract-plugin
module.exports = {"svg":"WuZA2ZQtM7Ht_LVi_t-32","isResetting":"_15ZlIo6fX1dAILcF78QEeU"};